import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgMultilayerPieChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3038 1.50177C14.6807 3.92434 8.24132 9.11401 4.25429 16.0483C0.267268 22.9825 -0.97824 31.1586 0.763165 38.9655L10.2872 36.8411C9.07679 31.4148 9.94249 25.732 12.7137 20.9122C15.4849 16.0925 19.9607 12.4854 25.2592 10.8015L22.3038 1.50177Z",
			fill: "#E2EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.76818 42.5013C3.28682 46.8721 5.7353 50.8616 8.94481 54.1948C12.1543 57.5279 16.0485 60.1253 20.3589 61.808L23.9074 52.718C20.9114 51.5485 18.2047 49.7431 15.9739 47.4264C13.7431 45.1096 12.0413 42.3367 10.9857 39.2987L1.76818 42.5013Z",
			fill: "#E2EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.435 63.3188C31.6766 64.6263 38.1666 64.0392 44.0722 61.6326C49.9778 59.2261 55.0297 55.1099 58.5796 49.8122L50.4733 44.3802C48.0059 48.0624 44.4945 50.9234 40.3898 52.5961C36.285 54.2688 31.7741 54.6769 27.4358 53.7681L25.435 63.3188Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.5574 46.43C62.3775 42.8275 63.4997 38.9133 63.8648 34.8937L54.1467 34.0111C53.893 36.805 53.113 39.5256 51.8479 42.0295L60.5574 46.43Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.9182 29.7675C63.3656 21.8637 59.9006 14.446 54.1938 8.94996L47.4248 15.9786C51.3914 19.7986 53.7998 24.9544 54.1839 30.448L63.9182 29.7675Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.0859 5.60322C43.0854 0.805295 34.4656 -1.01516 26.1228 0.542335L27.9136 10.1347C33.7123 9.05212 39.7036 10.3174 44.5694 13.6523L50.0859 5.60322Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.033 13.1395C23.4571 14.1008 19.3868 16.6928 16.5803 20.4326C13.7738 24.1724 12.4226 28.805 12.7784 33.4671C13.1342 38.1293 15.1727 42.5032 18.5142 45.7738C21.8557 49.0445 26.2723 50.9888 30.941 51.2446L31.5415 40.2841C29.5319 40.174 27.6308 39.3371 26.1924 37.9292C24.7541 36.5214 23.8766 34.6387 23.7235 32.6319C23.5703 30.6251 24.152 28.631 25.36 27.0212C26.568 25.4114 28.3201 24.2957 30.2898 23.8819L28.033 13.1395Z",
			fill: "#E2EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4101 50.4456C29.2757 51.3134 32.304 51.5015 35.255 50.9951C38.2059 50.4888 40.9983 49.3019 43.4107 47.5285C45.8231 45.7551 47.7891 43.4441 49.1529 40.7786C50.5167 38.1132 51.2408 35.1667 51.2676 32.1727L40.2911 32.0743C40.2796 33.363 39.9679 34.6313 39.3809 35.7787C38.7938 36.926 37.9475 37.9208 36.9091 38.6841C35.8707 39.4474 34.6688 39.9584 33.3985 40.1763C32.1283 40.3943 30.8248 40.3133 29.5913 39.9398L26.4101 50.4456Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.2675 32.1869C51.2963 29.2309 50.6446 26.3078 49.3629 23.6438C48.0813 20.9799 46.204 18.6465 43.8763 16.8242C41.5486 15.0018 38.8328 13.7393 35.9392 13.1345C33.0455 12.5296 30.0515 12.5984 27.1887 13.3358L29.9265 23.9658C31.1587 23.6484 32.4475 23.6188 33.6931 23.8791C34.9386 24.1395 36.1076 24.6829 37.1096 25.4674C38.1115 26.2518 38.9196 27.2562 39.4713 28.4029C40.023 29.5495 40.3035 30.8078 40.2911 32.0802L51.2675 32.1869Z",
			fill: "#BFDBFE"
		})
	]
});
export default SvgMultilayerPieChart;
